// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2YjUe","approved":"Status_approved__2BXw7","rejected":"Status_rejected__3hCGb","expired":"Status_expired__2b-oS","label":"Status_label__2rarn"};